var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"Header",attrs:{"id":"Header"}},[_c('div',{ref:"header-fixed",staticClass:"header-fixed"},[_c('div',{staticClass:"left"},[(
          (_vm.$route.meta.menuLevel !== 0 &&
            _vm.$route.matched &&
            1 < _vm.$route.matched.length) ||
          _vm.$route.meta.goBack
        )?_c('router-link',{staticClass:"left goBack",attrs:{"to":""}},[_c('div',{staticClass:"back",on:{"click":function($event){return _vm.$router.back(-1)}}},[_c('a-icon',{attrs:{"type":"rollback"}})],1)]):_vm._e()],1),_c('div',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(_vm.$route.meta.title))])]),_c('div',{staticClass:"right"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }